import React, { useState } from "react";
import { ResponsiveLine } from "@nivo/line";
import { linearGradientDef } from "@nivo/core";

const toolTipElement = (props) => {
  return (
    <div>
      <div
      
        className="video-tooltip-graph"
      >
        <p className="Tooltip-graph-date">{props.point?.data?.y}</p>
        <p className="Tooltip-graph-tx">{props.point?.data?.x || 0}</p>
      </div>
    </div>
  );
};

export default function Graph(props) {
  const [toggleState, setToggleState] = useState(6);
  const [points, setPoints] = useState({ x: 0, y: 0 });

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const MouseMovePoint = (event) => {
    const x = event.x;
    const y = event.y;
    setPoints({ ...points, x, y });
  };

  const CustomPoint = () => {
    return (
      <g>
        <circle
          fill="#3763dd"
          r={2}
          strokeWidth={1}
          stroke={2}
          cx={points.x}
          cy={points.y}
        />
      </g>
    );
  };

  const graphProperties = {
    //  height: 200,
    // margin: { top: 5, right: 0, bottom: 0, left: 0 },
    curve: "monotoneX",
    axisTop: null,
    axisRight: null,
    // axisBottom: null,
    // axisLeft: null,
    enableGridX: false,
    enableGridY: false,
    enableSlices: false,
    enablePoints: false,
    enableArea: true,
    areaOpacity: 0.9,
    useMesh: true,
    animate: true,
  };

  let oneDayDataset = !props?.oneDayData  ? "":   props?.oneDayData[0]?.data.map((item) => item.x.slice(0, 3));
  const OneDay = ({ CustomPoint, MouseMovePoint }) => (
    <ResponsiveLine
      {...graphProperties}
      data={props?.oneDayData}
      tooltip={toolTipElement}
      // margin={{ top: 10, right: 10 }}
      margin={{ top: 10, right: 15, bottom: 35, left: 15 }}
      layers={[
        "grid",
        "markers",
        "axes",
        "areas",
        "lines",
        "points",
        "slices",
        "mesh",
        "legends",
        CustomPoint,
      ]}
      colors={{ scheme: "paired" }}
      xScale={{ type: "point" }}
      defs={[
        linearGradientDef("gradientA", [
          { offset: 0, color: "inherit" },
          { offset: 100, color: "inherit", opacity: 0 },
        ]),
      ]}
      fill={[{ match: "*", id: "gradientA" }]}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: true,
        reverse: false,
      }}
      axisBottom={{
        orient: 'bottom',
        tickSize: 0,
        tickPadding: 25,
        // tickRotation: 0,
        // legend: '',
        // legendOffset: 42,
        // legendPosition: 'middle',
        // tickValues: 1,
        format: (values) => {
          // console.log(values);
          const mth = values.toString().slice(0, 3);
          if (oneDayDataset.includes(mth)) {
            oneDayDataset = oneDayDataset.filter((item) => item !== mth);
            console.log(values, "upper values")
            values = values.toString().slice(4,11);
            console.log(values, "values")
            return values;
          } else return "";
        },
    }}
    axisLeft={{
        orient: 'left',
        tickSize: 0,
        tickPadding: 2,
        // tickRotation: 0,
        // legend: '',
        // legendOffset: -40,
        // legendPosition: 'middle'
        tickValues:2,
    }}
      yFormat=" >-.2f"
      // colors={["#ffe5b2"]}
      enablePoints={false}
      pointSize={10}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabelYOffset={-12}
      legends={[]}
      onMouseMove={MouseMovePoint}
      theme={{
        fontSize: 9,
        fontWeight: 500,
        axis: {
          ticks: {
            text: {
              fill: "#535877",
              fontFamily: "barlow",
              color: "#535877",
              fontWeight: 500,
            },
          },
        },
      }}
    />
  );

  let onefiveDataset = !props?.fiveDayData  ? "":   props?.fiveDayData[0]?.data.map((item) => item.x.slice(0, 3));
  const FiveDays = ({ CustomPoint, MouseMovePoint }) => (
    <ResponsiveLine
      {...graphProperties}
      data={props?.fiveDayData}
      tooltip={toolTipElement}
      // margin={{ top: 10, right: 10 }}
      margin={{ top: 10, right: 15, bottom: 35, left: 15 }}
      layers={[
        "grid",
        "markers",
        "axes",
        "areas",
        "lines",
        "points",
        "slices",
        "mesh",
        "legends",
        CustomPoint,
      ]}
      colors={{ scheme: "paired" }}
      xScale={{ type: "point" }}
      defs={[
        linearGradientDef("gradientA", [
          { offset: 0, color: "inherit" },
          { offset: 100, color: "inherit", opacity: 0 },
        ]),
      ]}
      fill={[{ match: "*", id: "gradientA" }]}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: true,
        reverse: false,
      }}
      axisBottom={{
        orient: 'bottom',
        tickSize: 0,
        tickPadding: 25,
        // tickRotation: 0,
        // legend: '',
        // legendOffset: 42,
        // legendPosition: 'middle',
        // tickValues: 1,
        format: (values) => {
          // console.log(values);
          const mth = values.toString().slice(0, 3);
          if (onefiveDataset.includes(mth)) {
            onefiveDataset = onefiveDataset.filter((item) => item !== mth);
           
            values = values.toString().slice(0,3);
            
            return values;
          } else return "";
        },
    }}
    axisLeft={{
        orient: 'left',
        tickSize: 0,
        tickPadding: 2,
        // tickRotation: 0,
        // legend: '',
        // legendOffset: -40,
        // legendPosition: 'middle'
        tickValues:2,
    }}
      yFormat=" >-.2f"
      // colors={["#ffe5b2"]}
      enablePoints={false}
      pointSize={10}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabelYOffset={-12}
      legends={[]}
      onMouseMove={MouseMovePoint}
      theme={{
        fontSize: 9,
        fontWeight: 500,
        axis: {
          ticks: {
            text: {
              fill: "#535877",
              fontFamily: "barlow",
              color: "#535877",
              fontWeight: 500,
            },
          },
        },
      }}
    />
  );

  let oneMonthDataset = !props?.oneMonthData  ? "":   props?.oneMonthData[0]?.data.map((item) => item.x.slice(0, 3));

  const OneMonth = ({ CustomPoint, MouseMovePoint }) => (
    <ResponsiveLine
      {...graphProperties}
      data={props?.oneMonthData}
      tooltip={toolTipElement}
      // margin={{ top: 10, right: 10 }}
      margin={{ top: 10, right: 15, bottom: 35, left: 15 }}
      layers={[
        "grid",
        "markers",
        "axes",
        "areas",
        "lines",
        "points",
        "slices",
        "mesh",
        "legends",
        CustomPoint,
      ]}
      colors={{ scheme: "paired" }}
      xScale={{ type: "point" }}
      defs={[
        linearGradientDef("gradientA", [
          { offset: 0, color: "inherit" },
          { offset: 100, color: "inherit", opacity: 0 },
        ]),
      ]}
      fill={[{ match: "*", id: "gradientA" }]}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: true,
        reverse: false,
      }}
      axisBottom={{
        orient: 'bottom',
        tickSize: 0,
        tickPadding: 25,
        // tickRotation: 0,
        // legend: '',
        // legendOffset: 42,
        // legendPosition: 'middle',
        // tickValues: 1,
        format: (values) => {
          // console.log(values);
          const mth = values.toString().slice(0, 3);
          if (oneMonthDataset.includes(mth)) {
            oneMonthDataset = oneMonthDataset.filter((item) => item !== mth);
           
            values = values.toString().slice(4,11);
            return values;
          } else return "";
        },
    }}
    axisLeft={{
        orient: 'left',
        tickSize: 0,
        tickPadding: 2,
        // tickRotation: 0,
        // legend: '',
        // legendOffset: -40,
        // legendPosition: 'middle'
        tickValues:2,
    }}
      yFormat=" >-.2f"
      // colors={["#ffe5b2"]}
      enablePoints={false}
      pointSize={10}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabelYOffset={-12}
      legends={[]}
      onMouseMove={MouseMovePoint}
      theme={{
        fontSize: 9,
        fontWeight: 500,
        axis: {
          ticks: {
            text: {
              fill: "#535877",
              fontFamily: "barlow",
              color: "#535877",
              fontWeight: 500,
            },
          },
        },
      }}
    />
  );
  
  let data = props.oneYearData;
  let oneYearDataset = !data  ? "":   data[0]?.data.map((item) => item.x.slice(0, 3));

  const OneYear = ({ CustomPoint, MouseMovePoint }) => (
    <ResponsiveLine
      {...graphProperties}
      data={props?.oneYearData}
      tooltip={toolTipElement}
      // margin={{ top: 10, right: 10 }}
      margin={{ top: 10, right: 15, bottom: 35, left: 15 }}

      layers={[
        "grid",
        "markers",
        "axes",
        "areas",
        "lines",
        "points",
        "slices",
        "mesh",
        "legends",
        CustomPoint,
      ]}
      colors={{ scheme: "paired" }}
      xScale={{ type: "point" }}
      defs={[
        linearGradientDef("gradientA", [
          { offset: 0, color: "inherit" },
          { offset: 100, color: "inherit", opacity: 0 },
        ]),
      ]}
      fill={[{ match: "*", id: "gradientA" }]}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: true,
        reverse: false,
      }}
      axisBottom={{
        orient: 'bottom',
        tickSize: 0,
        tickPadding: 25,
        // tickRotation: 0,
        // legend: '',
        // legendOffset: 42,
        // legendPosition: 'middle',
        // tickValues: 1,
        format: (values) => {
          // console.log(values);
          const mth = values.toString().slice(0, 3);
          if (oneYearDataset.includes(mth)) {
            oneYearDataset = oneYearDataset.filter((item) => item !== mth);
           
            values = values.toString().slice(0,3);
            return values;
          } else return "";
        },
    }}
    axisLeft={{
        orient: 'left',
        tickSize: 0,
        tickPadding: 2,
        // tickRotation: 0,
        // legend: '',
        // legendOffset: -40,
        // legendPosition: 'middle'
        tickValues:2,
    }}
      yFormat=" >-.2f"
      // colors={["#ffe5b2"]}
      enablePoints={false}
      pointSize={10}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabelYOffset={-12}
      legends={[]}
      onMouseMove={MouseMovePoint}
      theme={{
        fontSize: 9,
        fontWeight: 500,
        axis: {
          ticks: {
            text: {
              fill: "#535877",
              fontFamily: "barlow",
              color: "#535877",
              fontWeight: 500,
            },
          },
        },
      }}
    />
  );

  let five = props?.fiveYearData;
  let oneFiveYearDataset = !five  ? "":   five[0]?.data.map((fiveitem) => fiveitem.x.slice(0, 3));

  const FiveYear = ({ CustomPoint, MouseMovePoint }) => (
    <ResponsiveLine
      {...graphProperties}
      data={props?.fiveYearData}
      tooltip={toolTipElement}
      // margin={{ top: 10, right: 10 }}
    margin={{ top: 10, right: 15, bottom: 35, left: 15 }}

      layers={[
        "grid",
        "markers",
        "axes",
        "areas",
        "lines",
        "points",
        "slices",
        "mesh",
        "legends",
        CustomPoint,
      ]}
      colors={{ scheme: "paired" }}
      xScale={{ type: "point" }}
      defs={[
        linearGradientDef("gradientA", [
          { offset: 0, color: "inherit" },
          { offset: 100, color: "inherit", opacity: 0 },
        ]),
      ]}
      fill={[{ match: "*", id: "gradientA" }]}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: true,
        reverse: false,
      }}
      axisBottom={{
        orient: 'bottom',
        tickSize: 0,
        tickPadding: 25,
        // tickRotation: 0,
        // legend: '',
        // legendOffset: 42,
        // legendPosition: 'middle',
        // tickValues: 1,
        format: (values) => {
          // console.log(values);
          const mth = values.toString().slice(0, 3);
          if (oneFiveYearDataset.includes(mth)) {
            oneFiveYearDataset = oneFiveYearDataset.filter((fiveitem) => fiveitem !== mth);
           
            values = values.toString().slice(7,12);
            return values;
          } else return "";
        },
    }}
    axisLeft={{
        orient: 'left',
        tickSize: 0,
        tickPadding: 2,
        // tickRotation: 0,
        // legend: '',
        // legendOffset: -40,
        // legendPosition: 'middle'
        tickValues:2,
    }}
      yFormat=" >-.2f"
      // colors={["#ffe5b2"]}
      enablePoints={false}
      pointSize={10}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabelYOffset={-12}
      legends={[]}
      onMouseMove={MouseMovePoint}
      theme={{
        fontSize: 9,
        fontWeight: 500,
        axis: {
          ticks: {
            text: {
              fill: "#535877",
              fontFamily: "barlow",
              color: "#535877",
              fontWeight: 500,
            },
          },
        },
      }}
    />
  );

  return (
    <div className="container">
      <div className="block">
        <div className="bloc-tabs">
          <button
            className={
              toggleState === 1 ? "tabs-list active-tabs-list" : "tabs-list"
            }
            onClick={() => toggleTab(1)}
          >
            <span
              className={
                toggleState === 1 ? "selectedTab-mode" : "listTab-mode"
              }
            >
              1D
            </span>
          </button>
          <button
            className={
              toggleState === 2 ? "tabs-list active-tabs-list" : "tabs-list"
            }
            onClick={() => toggleTab(2)}
          >
            <span
              className={
                toggleState === 2 ? "selectedTab-mode" : "listTab-mode"
              }
            >
              5D
            </span>
          </button>
          <button
            className={
              toggleState === 3 ? "tabs-list active-tabs-list" : "tabs-list"
            }
            onClick={() => toggleTab(3)}
          >
            <span
              className={
                toggleState === 3 ? "selectedTab-mode" : "listTab-mode"
              }
            >
              1M
            </span>
          </button>
          <button
            className={
              toggleState === 4 ? "tabs-list active-tabs-list" : "tabs-list"
            }
            onClick={() => toggleTab(4)}
          >
            <span
              className={
                toggleState === 4 ? "selectedTab-mode" : "listTab-mode"
              }
            >
              1Y
            </span>
          </button>
          <button
            className={
              toggleState === 5 ? "tabs-list active-tabs-list" : "tabs-list"
            }
            onClick={() => toggleTab(5)}
          >
            <span
              className={
                toggleState === 5 ? "selectedTab-mode" : "listTab-mode"
              }
            >
              5Y
            </span>
          </button>
          <button
            className={
              toggleState === 6 ? "tabs-list active-tabs-list" : "tabs-list"
            }
            onClick={() => toggleTab(6)}
          >
            <span
              className={
                toggleState === 6 ? "selectedTab-mode" : "listTab-mode"
              }
            >
              Max
            </span>
          </button>
        </div>
      </div>
      <div className="content-tabs">
        <div
          className={toggleState === 1 ? "content  active-content" : "content"}
        >
          {props?.oneDayDataLength != 0 ? (
            <div className="LineGraph">
              {" "}
              <OneDay
                MouseMovePoint={MouseMovePoint}
                CustomPoint={CustomPoint}
              />
            </div>
          ) : (
            <div className="graphNoDataFound">No Data Found</div>
          )}
        </div>

        <div
          className={toggleState === 2 ? "content  active-content" : "content"}
        >
          {props?.fiveDayDataLength != 0 ? (
            <div className="LineGraph">
              <FiveDays
                MouseMovePoint={MouseMovePoint}
                CustomPoint={CustomPoint}
              />
            </div>
          ) : (
            <div className="graphNoDataFound">No Data Found</div>
          )}
        </div>
        <div
          className={toggleState === 3 ? "content  active-content" : "content"}
        >
          {props?.oneMonthDataLength != 0 ? (
            <div className="LineGraph">
              {" "}
              <OneMonth
                MouseMovePoint={MouseMovePoint}
                CustomPoint={CustomPoint}
              />
            </div>
          ) : (
            <div className="graphNoDataFound">No Data Found</div>
          )}
        </div>

        <div
          className={toggleState === 4 ? "content  active-content" : "content"}
        >
          {props?.oneYearDataLength != 0 ? (
            <div className="LineGraph">
              {" "}
              <OneYear
                MouseMovePoint={MouseMovePoint}
                CustomPoint={CustomPoint}
              />
            </div>
          ) : (
            <div className="graphNoDataFound">No Data Found</div>
          )}
        </div>
        <div
          className={toggleState === 5 ? "content  active-content" : "content"}
        >
          {props?.fiveYearDataLength != 0 ? (
            <div className="LineGraph">
              {" "}
              <FiveYear
                MouseMovePoint={MouseMovePoint}
                CustomPoint={CustomPoint}
              />
            </div>
          ) : (
            <div className="graphNoDataFound">No Data Found</div>
          )}
        </div>
        <div
          className={toggleState === 6 ? "content  active-content" : "content"}
        >
          {props?.fiveYearDataLength != 0 ? (
            <div className="LineGraph">
              {" "}
              <FiveYear
                MouseMovePoint={MouseMovePoint}
                CustomPoint={CustomPoint}
              />
            </div>
          ) : (
            <div className="graphNoDataFound">No Data Found</div>
          )}
        </div>
      </div>
    </div>
  );
}
